import React, { useState, useRef } from "react";
import InputField from "../../InputField/InputField";
import TinyEditor from "../../TextEditor/Editor";
import Button from "../../Button/Button";
import useMultiUpload from "../../../utils/CustomHooks/useMultiUpload";
import close from "../../../assets/svg/close.svg";
import CustomUploadBox from "../../CustomUploadBox/CustomUploadBox";
import { useEffect } from "react";
import { TagsInput } from "react-tag-input-component";
import "./EditBlogPopup.css"
import CustomRadioButton from "../../CustomRadioButton/CustomRadioButton";
import CustomSearchableDropdown from "../CustomSearchableDropdown/CustomSearchableDropdown";
import FaqSection from "../../FaqSection/FaqSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserForBlogs } from "../../../redux/blogs/blogSlice";
import Cookies from 'js-cookie'

const SPECIAL_ORG_ID = "52c3b93c-59ba-44e7-8e99-bd5fc889b68f";

const EditBlogPopup = ({
  isActive,
  onSubmit,
  onClickClosePopup,
  blogId,
  blogDetails,
   isEditTemplatePopupFetching
}) => {
  console.log("blogID", blogId, blogDetails);
  const {
    isBlogSliceFetching,
    isBlogSliceFetchingSmall,
    isBlogSliceSuccess,
    isBlogCreateSuccess,
    isBlogSliceError,
    isBlogDraftCreateSuccess,
    blogSliceErrorMessage,
    blogSliceSuccessMessage,
    toggleSaveAsDraftPopup,
    blogsUsers
  } = useSelector((state) => state.blog);
  const {
    isFileUploading,
    fileUploadError,
    fileUploadSuccess,
    uploadedFileData,
    uploadFile,
  } = useMultiUpload();
  const SmallImageRef = React.useRef(null);
  const ThumbnailRef = React.useRef(null);
  const [SmallImageName, setSmallImageName] = useState(null);
    const [authorImage , setAuthorImage] = useState(null)
  
  const [thumbnailName, setThumbnailName] = useState(null);
  const [uploadingField, setUploadingField] = useState(null);
const [isArticle , setIsArticle] = useState(false);
const dispatch = useDispatch()
  const authorImageRef = React.useRef(null)

  const [userId , setUserId] = useState(null)

  useEffect(() => {
    dispatch(fetchUserForBlogs())
    }, [])

const [formData, setFormData] = useState({
  blog_Title: "",
  blog_Type: "",
  blog_Description: "",
  smallImage: "",
  thumbnail: "",
  blog_Body: "",
  blog_isActive:"",
  id: blogId,
  wordCount:0,
  readingTime:0,
  selectedTag:[] ,
  youtubeUrl : "",
  articleLink :"" ,
  isArticle : "false",
  membersOnly : "false",
  categories : [] ,
  author : "" ,
    authorName : "",
    authorImage : "",
    altImg : "",
    metaTitle : "",
    faqs: [],
    // Non-SPECIAL_ORG_ID only — see the summary block near the FAQ section.
    summary: "",
    redirectProgrammeUrl: "",
    additionalTags: []
});

const categoriesOption = [
  {value : "Admissions Advice" , label : "Admissions Advice" },
  {value : "Mentor Spotlight" , label : "Mentor Spotlight" },
  {value : "CXO Insights" , label : "CXO Insights" },
  {value : "Unique Courses" , label : "Unique Courses" },
  {value : "Placement Success" , label : "Placement Success" },
  {value : "Outclass" , label : "Outclass" },
  {value : "Startup Stories" , label : "Startup Stories" },
  {value : "Research Papers" , label : "Research Papers" },
  {value : "MBA Insights" , label : "MBA Insights" },
  {value : "AI Careers" , label : "AI Careers" },
  // {value : "Marketing Trends" , label : "Marketing Trends" },
  // {value : "Finance Trends" , label : "Finance Trends" },
  // {value : "Student Life" , label : "Student Life" },
  // {value : "Off Campus" , label : "Off Campus" },
  // {value : "Campus Learning" , label : "Campus Learning" },
]


const [defaultValue , setDefaultValue] = useState([]);
const [selectedAuthor , setSelectedAuthor] = useState(null)
const initialLoginCookie = Cookies.get("loginData");
const [orgId , setOrgId] = useState(() => {
  if (!initialLoginCookie) return null;
  try {
    return JSON.parse(initialLoginCookie)?.organizationId ?? null;
  } catch {
    return null;
  }
});
    const cookieLoginData = Cookies.get("loginData");
  
    useEffect(() => {
      if (cookieLoginData) {
        const parsedLoginData = JSON.parse(cookieLoginData);
        
        setOrgId(parsedLoginData?.organizationId ?? null);
        setUserId(parsedLoginData.id)
      }
    }, [cookieLoginData]);
useEffect(() => {
    if (blogDetails) {
      const smallImageName = blogDetails?.smallImage?.split('/').pop();
      const fileName = smallImageName?.split('_').pop();
      
      const thumbnailName=blogDetails?.thumbNail?.split('/').pop();
      const thumbnailFileName=thumbnailName?.split('_').pop();
      const authorImage = blogDetails?.authorImage?.split('/').pop()
      const authorImageName = authorImage?.split('_').pop()
      setFormData({
        blog_Title: blogDetails?.blog_Title,
        blog_Type: blogDetails?.blog_Type,
        blog_Description: blogDetails?.blog_description,
        smallImage: blogDetails?.smallImage,
        thumbnail: blogDetails?.thumbNail,
        blog_Body: blogDetails?.blog_Body,
        blog_isActive:blogDetails?.blog_isActive,
        wordCount:blogDetails?.blog_wordCount,
        readingTime:blogDetails?.blog_readingTime,
        selectedTag:blogDetails?.tags,
        youtubeUrl : blogDetails?.youtubeUrl ,
        articleLink :blogDetails?.articleLink ,
        isArticle : blogDetails?.isArticle,
        membersOnly : blogDetails?.membersOnly,
        categories : blogDetails?.categories ,
        author : blogDetails?.author ,
          authorName : blogDetails?.authorName,
    authorImage : blogDetails?.authorImage,
    categories: blogDetails?.categories,
    blog_isActive : blogDetails?.blog_isActive,
    altImg : blogDetails?.altImg,
    metaTitle : blogDetails?.metaTitle,
    faqs:
      Array.isArray(blogDetails?.FAQData)
        ? blogDetails.FAQData
        : Array.isArray(blogDetails?.faqs)
          ? blogDetails.faqs
          : [],
    summary: blogDetails?.summary ?? "",
    redirectProgrammeUrl: blogDetails?.redirectProgrammeUrl ?? "",
    // TagsInput requires an array — blogs created before this field existed
    // return null and would otherwise crash the input.
    additionalTags: Array.isArray(blogDetails?.additionalTags)
      ? blogDetails.additionalTags
      : [],
      });
      setSmallImageName(fileName);
      setThumbnailName(thumbnailFileName)
      setAuthorImage(authorImageName)
    }
  }, [blogDetails, orgId]);

// useEffect(() => {
 

//     setDefaultValue(categoriesOption.filter((ele)=>  blogDetails?.categories.includes(ele.value)))

// }, [blogDetails , formData])

useEffect(() => {
  if(formData?.author){
    setSelectedAuthor(blogsUsers.find((ele)=> ele.value== formData?.author))
  }

}, [blogDetails , formData])


console.log(formData , "formDaaaaaaaaaaaaaaa");
console.log(selectedAuthor , "sssss"); 
console.log(defaultValue , "2222222222"); 




  const onClickUpload = async (event, name) => {
    if (event.target.files.length > 0) {
      console.log("in onClickUpload");
      const files = event.target.files;
      const fileFor = event.target.fileFor;
      setUploadingField(name);

      await uploadFile(files, fileFor);
    }
  };
  const handleClick = (ref) => {
    if (ref.current) ref.current.click();
  };
  useEffect(() => {
    if (fileUploadSuccess && !isFileUploading) {
      switch (uploadingField) {
        case "smallImage":
          setFormData(prevFormData => ({
            ...prevFormData,
            smallImage: uploadedFileData[0]?.url,
          }));
           setSmallImageName(uploadedFileData[0]?.name);
       
          break;
         
        case "thumbnail":
       
          setFormData(prevFormData => ({
            ...prevFormData,
            thumbnail: uploadedFileData[0]?.url,
          }));
          setThumbnailName(uploadedFileData[0]?.name);
          break;
          case "authorImage":
            setFormData({
              ...formData,
              [uploadingField]: uploadedFileData[0].url,
            });
            setAuthorImage(uploadedFileData[0].name);
            break;
      }
    }
  }, [isFileUploading]);
  const onChangeFormData = (data) => {
    const { name, value } = data.target;
    console.log(name , value)
    if(name == "isArticle" && value == "false"){
      setFormData({
        ...formData,
         articleLink: null,
         isArticle : false
      });
    }else if(name == "membersOnly" && value == "false"){
      setFormData({
        ...formData,
        membersOnly: false,
         
      });
    }
    else{

      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const handleRemoveImage = (uploadingField) => {
    // setFormData({
    //   ...formData,
    //   [fieldName]: "", 
    // });
    console.log("upoading",uploadingField)
    switch (uploadingField) {
      case "smallImage":
        setFormData({
          ...formData,
          [uploadingField]: "",
        });
        setSmallImageName("");
        break;
        

      case "thumbnail":
        setFormData({
          ...formData,
          [uploadingField]:"",
        });
        setThumbnailName("");
        break;
        case "authorImage":
          setFormData({
            ...formData,
            [uploadingField]:"",
          });
          setAuthorImage("");
          break;
    }
  };
  const handleTemplateBodyChange = (content,words) => {
    console.log("con", content);
    setFormData((prevData) => ({
      ...prevData,
      blog_Body: content,
      wordCount:words,
      readingTime: Math.ceil(words / 200)
    }));
  };
  const onChangeFormTagData = (newTags) => {
    setFormData({
      ...formData,
      selectedTag: newTags,
    });
  
    
  };

  const onChangeFormCategortyData = (obj , field) => {

    console.log(obj ,"objjj");
    console.log(field ,"field");
    const data = obj.map((ele)=> ele.value)

    const {label , value } = obj;

    setFormData((prev) => ({
      ...prev,
      categories: data
    }));


   
  };


  const onChangeFormAuthorData = (obj , field) => {

    console.log(obj ,"objjj");
    console.log(field ,"field");
    // const data = obj.map((ele)=> ele.value)

    const {label , value } = obj;

    setFormData((prev) => ({
      ...prev,
      author: obj.value
    }));


   
  };

  const onChangeFaqs = (nextFaqs) => {
    setFormData((prev) => ({
      ...prev,
      faqs: nextFaqs,
    }));
  };

  const handleSummaryChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      summary: content,
    }));
  };

  const onChangeAdditionalTags = (newTags) => {
    setFormData((prev) => ({
      ...prev,
      additionalTags: newTags,
    }));
  };

  const handleSubmit = () => {
    let newObj = {
      blog_Title: formData?.blog_Title,
      blog_Type: formData?.blog_Type,
      blog_Description: formData?.blog_Description,
      smallImage: formData?.smallImage,
      thumbnail: formData?.thumbnail,
      blog_Body: formData?.blog_Body,
      blog_isActive: formData?.blog_isActive,
      wordCount:formData?.wordCount,
      readingTime:formData?.readingTime,
      selectedTag:formData?.selectedTag,
      youtubeUrl : formData?.youtubeUrl ,
      articleLink : formData?.articleLink ,
      isArticle : formData?.isArticle ,
      membersOnly : formData?.membersOnly ,
      categories : formData?.categories,
      author : formData?.author,
      authorImage : formData?.authorImage,
      authorName : formData?.authorName,
      altImg : formData?.altImg,
      metaTitle : formData?.metaTitle,
      FAQData: formData?.faqs || [],
      id:blogId,
      userId : userId ? userId : "",
      version : blogDetails?.version +1
    };
    if (orgId != SPECIAL_ORG_ID) {
      newObj.summary = formData?.summary;
      newObj.redirectProgrammeUrl = formData?.redirectProgrammeUrl;
      newObj.additionalTags = formData?.additionalTags || [];
    }
    console.log(newObj);

    console.log("Template edited!", newObj);
    onSubmit(newObj);
  };

  console.log(defaultValue , "default VaLUE DEFAULT VALUE ");
  console.log(blogDetails?.author , "blogDetails?.author");
  
   console.log(blogsUsers.find((ele)=> ele.value == blogDetails?.author))
   
useEffect(()=>{
  console.log("formdata",formData)
},[formData])
  return (
    <div className={`popupWrapper ${isActive && "active"}`}>
      <div className="popupContainer editBlog" >
        <div className="popupHeader">
          <h4 className="popupHeading">Edit Blog Template</h4>
          <span className="close" onClick={onClickClosePopup}>
            <img src={close} alt="" />
          </span>
        </div>
        <div className="popupBody">
          <InputField
            name="blog_Title"
            className={"mb-20"}
            labelName={"Blog Title"}
            placeholder={"Enter Blog Title"}
            onChange={onChangeFormData}
            value={formData?.blog_Title}
          />
          <InputField
            name="blog_Type"
            className={"mb-20"}
            labelName={"Blog Type"}
            placeholder={"Enter Blog Type"}
            onChange={onChangeFormData}
            value={formData?.blog_Type}
          />
          <InputField
            name="blog_Description"
            className={"mb-20"}
            labelName={"Blog Description"}
            placeholder={"Enter Blog Description"}
            onChange={onChangeFormData}
            value={formData?.blog_Description}
          />
            <InputField
          name="youtubeUrl"
          className={"mb-20"}
          labelName={"Youtube Link"}
          notImp={true}
          placeholder={"Enter link"}
          onChange={onChangeFormData}
          value={formData.youtubeUrl}
        />
          <div className="formGroups">

<label>
{"Is this An Article ?"}
</label>
</div>
<div className="popupBody" style={{display : "flex" , padding: "10px" }}>

           <CustomRadioButton name={'isArticle'} text={'Yes'} label={'Yes'} value= {true} className={"radioButton"} checked={formData?.isArticle == true || formData?.isArticle === "true" } onChange={onChangeFormData} />
           <CustomRadioButton name={'isArticle'} text={'No'} label={'No'} value= {false} className={"radioButton"} checked={formData?.isArticle == false || formData?.isArticle === "false"} onChange={onChangeFormData} />
</div>




{(formData?.isArticle === "true" || formData?.isArticle == true) &&
<InputField
 name="articleLink"
 className={"mb-20"}
 labelName={"Article Link"}
 notImp={true}
 placeholder={"Enter link"}
 onChange={onChangeFormData}
 value={formData.articleLink}
/>
 }

{orgId != SPECIAL_ORG_ID &&
<>
          <div className="formGroups">

          <label>
          {"Is this Members Only ?"}
          </label>
          </div>
          <div className="popupBody" style={{display : "flex" , padding: "10px" }}>
          
                     <CustomRadioButton name={'membersOnly'} text={'Yes'} label={'Yes'} value= {true} className={"radioButton"} checked={formData?.membersOnly == true || formData?.membersOnly === "true" } onChange={onChangeFormData} />
                     <CustomRadioButton name={'membersOnly'} text={'No'} label={'No'} value= {false} className={"radioButton"} checked={formData?.membersOnly == false || formData?.membersOnly === "false"} onChange={onChangeFormData} />
          </div>
</>
}
          <TagsInput
        // value={selectedTag}
        // onChange={setSelectedTag}
        name="tags"
        placeHolder="Enter Tags"
        onChange={onChangeFormTagData}
          
          value={formData?.selectedTag}
      /> 
    { orgId != SPECIAL_ORG_ID && <CustomSearchableDropdown
          options={categoriesOption}
          isimp={false}
          isMulti={true}
           className="dropUpMenu mb-20 w100 zIndex"
           label={"Select Categories"}
            field="categories"
            onChange={onChangeFormCategortyData}
            defaultValue={formData?.categories && formData?.categories?.map((category) =>  ({label: category, value: category}))}
            value={formData?.categories?.map((category) =>  ({label: category, value: category}))}
            // value={formData?.categories}
          />}

{  orgId == SPECIAL_ORG_ID && 

<>
{/* <CustomSearchableDropdown
          options={blogsUsers}
          // isimp={false}
          // isMulti={true}
           className="dropUpMenu mb-20 w100 z499"
           label={"Select Author"}
                 field="author"
                 onChange={onChangeFormAuthorData}
                 value={selectedAuthor}

          /> */}
<InputField
name="authorName"
className={"mb-20"}
labelName={"Add Author"}
placeholder={"Enter Blog Author"}
onChange={onChangeFormData}
// isError={formErrors.authorName ? true : false}
// erroMessage={formErrors.authorName}
value={formData?.authorName}
/>



   <div className="uploadField">
{formData.authorImage !== null && formData.authorImage !== "" && (
<div className="imgPreview">
{formData.authorImage !== "" && <img src={formData.authorImage} alt="authorImage" />}
</div> )}
<div className="customField">
<CustomUploadBox
spacing={"formFileUploads"}
isimp={false}
label={"Author Image"}
onClickChooseFile={() => handleClick(authorImageRef)}
onChange={(e) => onClickUpload(e, "authorImage")}
isUploading={isFileUploading && uploadingField == "authorImage"}
fileName={authorImage}
fileFor={"authorImage"}
// isError={formErrors.authorImage ? true : false}
// erroMessage={formErrors.authorImage}
fileUrl={formData?.authorImage || formData?.authorImage}
onRemoveImage={handleRemoveImage}
acceptedFileTypes={".jpg ,.jpeg,.png"}
/>
</div>
</div>
</>


          }


<InputField
name="altImg"
className={"mb-20"}
labelName={"Add Alt Tag"}
placeholder={"Enter Alt for Image"}
onChange={onChangeFormData}
notImp = {true}
// isError={formErrors.authorName ? true : false}
// erroMessage={formErrors.authorName}
value={formData?.altImg}
/>

<InputField
name="metaTitle"
className={"mb-20"}
labelName={"Add Meta Title"}
placeholder={"Enter Meta Title"}
onChange={onChangeFormData}
notImp = {true}
// isError={formErrors.authorName ? true : false}
// erroMessage={formErrors.authorName}
value={formData?.metaTitle}
/>

      <div className="uploadField">
      {formData.smallImage !== null && formData.smallImage !== "" && (
      <div className="imgPreview">
        {formData.smallImage !== "" && <img src={formData.smallImage} alt="SmallImage" />}
   </div> )}
    <div className="customField">
          <CustomUploadBox
            spacing={"formFileUploads"}
            isimp={false}
            label={"Small Image"}
            onClickChooseFile={() => handleClick(SmallImageRef)}
            onChange={(e) => onClickUpload(e, "smallImage")}
            isUploading={isFileUploading && uploadingField == "smallImage"}
            fileName={SmallImageName}
            fileFor={"smallImage"}
            onRemoveImage={handleRemoveImage}
            fileUrl={formData?.smallImage || formData?.smallImage}
            acceptedFileTypes={".jpg ,.jpeg,.png"}
          />
          </div>
          </div>
          <div className="uploadField">
          {formData.thumbnail !== null && formData.thumbnail !== "" && (
      <div className="imgPreview">
        {formData.thumbnail !== "" && <img src={formData.thumbnail} alt="thumbnail" />}
      </div> )}
<div className="customField">
          <CustomUploadBox
            spacing={"formFileUploads"}
            isimp={false}
            label={"Thumbnail Image"}
            onClickChooseFile={() => handleClick(ThumbnailRef)}
            onChange={(e) => onClickUpload(e, "thumbnail")}
            isUploading={isFileUploading && uploadingField == "thumbnail"}
            fileName={thumbnailName}
            fileFor={"thumbnail"}
            onRemoveImage={handleRemoveImage}
            fileUrl={formData?.thumbnail || formData?.thumbnail}
            acceptedFileTypes={".jpg ,.jpeg,.png"}
          />
          </div>
          </div>
          <TinyEditor
            onChange={handleTemplateBodyChange}
            initialValue={formData?.blog_Body}
          />
          <FaqSection
            label={"FAQs"}
            value={formData?.faqs}
            onChange={onChangeFaqs}
            remountKey={String(blogId ?? "")}
          />

          {/* Summary block — shown for every org except SPECIAL_ORG_ID */}
          {orgId != SPECIAL_ORG_ID && (
            <>
              <div className="formGroups">
                <label>Summary</label>
                {/* TinyEditor is uncontrolled: keying on blogDetails?.id remounts
                    it once the fetched blog lands, so saved summaries show up. */}
                <TinyEditor
                  key={`summary-${blogDetails?.id ?? "loading"}`}
                  initialValue={formData?.summary || ""}
                  onChange={handleSummaryChange}
                  height={300}
                />
              </div>

              <InputField
                name="redirectProgrammeUrl"
                className={"mb-20"}
                labelName={"Redirect Programme Page URL"}
                notImp={true}
                placeholder={"Enter programme page link"}
                onChange={onChangeFormData}
                value={formData?.redirectProgrammeUrl}
              />

              <div className="formGroups">
                <label>Additional Tags</label>
                <TagsInput
                  name="additionalTags"
                  placeHolder="Enter Tags"
                  onChange={onChangeAdditionalTags}
                  value={formData?.additionalTags}
                />
              </div>
            </>
          )}
          {/* <div className='formGroups'>
            <label htmlFor=''>
              Template Body
              <span className='impRed'> *</span>
            </label>
          </div> */}
        </div>
        <div className="popupFooter">
          <div className="buttonWrapper">
            <Button
              onClick={onClickClosePopup}
              className={"GreyFillButton"}
              name={"Cancel"}
            />
            <Button
              className={"BlueFillButton"}
              name={"Submit"}
              onClick={handleSubmit}
                isWaiting={isEditTemplatePopupFetching}
                disabled={isEditTemplatePopupFetching}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBlogPopup;
